export const textFriendlyGradients = [
  // Dark to darker gradients (for light text)
  'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
  'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
  'linear-gradient(135deg, #1a2980 0%, #26d0ce 100%)',
  'linear-gradient(135deg, #232526 0%, #414345 100%)',
  'linear-gradient(135deg, #000428 0%, #004e92 100%)',
  
  // Darker to dark gradients (for light text)
  'linear-gradient(135deg, #2c3e50 0%, #4ca1af 100%)',
  'linear-gradient(135deg, #16222a 0%, #3a6073 100%)',
  'linear-gradient(135deg, #1f4037 0%, #99f2c8 100%)',
  'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
  'linear-gradient(135deg, #1e1e2f 0%, #2a2a57 100%)',
  
  // Light to lighter gradients (for dark text)
  'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
  'linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)',
  'linear-gradient(135deg, #f6f9fc 0%, #e6e9f0 100%)',
  'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
  'linear-gradient(135deg, #f8f9fa 0%, #dee2e6 100%)',
  
  // Colorful gradients with good contrast
  'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #7db9e8 100%)',
  'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
  'linear-gradient(135deg, #1a2980 0%, #26d0ce 100%)',
  'linear-gradient(135deg, #4b6cb7 0%, #182848 100%)',
  'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)'
];

// Function to get a random gradient
// Use darkGradient = true for light text, false for dark text
export const getRandomGradient = (darkGradient = true) => {
  const darkGradients = textFriendlyGradients.slice(0, 10);
  const lightGradients = textFriendlyGradients.slice(10, 15);
  const colorfulGradients = textFriendlyGradients.slice(15);
  
  const targetArray = darkGradient 
    ? [...darkGradients, ...colorfulGradients]
    : [...lightGradients];
    
  const randomIndex = Math.floor(Math.random() * targetArray.length);
  return targetArray[randomIndex];
};

// Function to get a gradient by index
export const getGradientByIndex = (index: number) => {
  const safeIndex = index % textFriendlyGradients.length;
  return textFriendlyGradients[safeIndex];
};
